export const dashboard = {
  dashboard: {
    decoderFrameGraphTitle: 'Frames',
    detailedStatistics: 'Detailed Statistics',
    hideAudioChannels: 'Hide Audio Channels',
    manageStillImages: 'Manage Still Images...',
    noStatistics: 'NO STATISTICS AVAILABLE',
    streamGenericGraphTitle: 'STREAM BANDWIDTH',
    resetStatistics: 'Reset Statistics',
    resetAllStatistics: 'Reset All Statistics',
    showAudioChannels: 'Show Audio Channels',
    resetAllModal: {
      title: 'Reset All Statistics?',
      body: 'This will reset the statistics for all decoders and all streams. This cannot be undone.',
    },
    title: 'Dashboard',
    sdiOutputs: 'SDI',
    decoding: {
      title: 'DECODING',
      inUse: 'In Use',
      decoder: 'Decoder',
      decoders: 'Decoders',
      decoding: 'Decoding',
    },
    bandwidth: {
      title: 'NETWORK',
    },
    deviceStatus: {
      emsStatus: 'Haivision Services',
      firmware: 'Firmware',
      serialNumber: 'Serial Number',
      systemUptime: 'System Uptime',
      title: 'DEVICE STATUS',
    },
    statistics: {
      bitrate: 'BR',
      bitrateExplain: 'Bitrate (Send Rate)',
      dropped: 'DP',
      droppedExplain: 'Dropped Packets',
      latency: 'LAT',
      latencyExplain: 'Latency',
      rtt: 'RTT',
      rttExplain: 'Round-Trip Time',
    },
  },
};
